import React from 'react';
import { getPolyglot } from '../../../../../i18n';
import { Button } from '@mui/material';
import { DeleteIcon } from '../../../../../theme/icons';
interface DeleteGroupButtonProps {
  openDeleteGroup: () => void;
}
export const DeleteStoreButton = ({
  openDeleteGroup,
}: DeleteGroupButtonProps) => {
  const polyglot = getPolyglot();

  return (
    <Button
      variant="text"
      color="error"
      startIcon={<DeleteIcon />}
      onClick={openDeleteGroup}
    >
      {polyglot.t('freshwatch.store.delete')}
    </Button>
  );
};
